import React from "react";
import { Box, Card } from "@mui/material";
import { useErrorStyles } from "./summary-card.style";

/** Define the default height of the card */
const DIALOG_HEIGHT = "421px";

/** Props type for the error component */
interface MyCafeteriaSummaryCardErrorComponentProps {
  error: Error | string;
}

/** Error component is shown when data fetching failed with an error state */
export const MyCafeteriaSummaryCardErrorComponent: React.FC<
  MyCafeteriaSummaryCardErrorComponentProps
> = ({ error }) => {
  const classes = useErrorStyles({ height: DIALOG_HEIGHT, width: "100%" });

  return (
    <Card
      id="my-cafeteria-summary-card"
      variant="outlined"
      classes={{ root: classes.root }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100%"
        color="#cc0033"
      >
        <Box>{error.toString()}</Box>
      </Box>
    </Card>
  );
};

export default MyCafeteriaSummaryCardErrorComponent;
